// extracted by mini-css-extract-plugin
module.exports = {"theIdeaContent":"theIdea_theIdeaContent__ZcGlT","title":"theIdea_title__2f8Fy","text":"theIdea_text__2aY9h","error":"theIdea_error__3MIp3","errorText":"theIdea_errorText__3sNf6"};